import { render, staticRenderFns } from "./EditInventory.vue?vue&type=template&id=af1d80e6&scoped=true"
import script from "./EditInventory.vue?vue&type=script&lang=js"
export * from "./EditInventory.vue?vue&type=script&lang=js"
import style0 from "./EditInventory.vue?vue&type=style&index=0&id=af1d80e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d80e6",
  null
  
)

export default component.exports